// src/components/StudentSidebar.js
import { useState } from 'react';
import CommonSidebar from './CommonSidebar';

function StudentSidebar({ isOpen, onToggle }) {
  const menuItems = [
    { path: '/student', icon: '📊', label: 'Dashboard', exact: true },
    { path: '/student/courses', icon: '📚', label: 'My Courses' },
    { path: '/student/lessons', icon: '⏰', label: 'My Schedule' },
    { path: '/student/certificates', icon: '🏆', label: 'My Certificates' },
    { path: '/student/settings', icon: '⚙️', label: 'Settings' }
  ];

  return (
    <CommonSidebar
      isOpen={isOpen}
      onToggle={onToggle}
      userType="student"
      menuItems={menuItems}
      logoText={{ primary: "STUDENT", secondary: "PANEL" }}
    />
  );
}

export default StudentSidebar;